import { isNil } from 'lodash';
import { useRef } from 'react';
import { useDeviceType } from '../../../hooks/useDeviceType';

export function Logo({ active, image, onClick, isUserUploadedLogo, onDelete }) {
  const device = useDeviceType();
  const isMobile = device === 'mobile';
  const imageRef = useRef(null);

  const dragStart = (event) => {
    console.log('darg Start');
    onClick();
  };

  const computeRatio = () => {
    if (isNil(imageRef.current)) return 1;
    const image = imageRef.current;
    const width = image.naturalWidth;
    const height = image.naturalHeight;
    console.log('width', width, 'height', height);
    return width / height;
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete();
    }
  };

  return (
    <div
      onClick={() => {
        const ratio = computeRatio();
        onClick(ratio);
      }}
      style={{
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'visible',
      }}
    >
      <div
        className={`logoItem ${active ? 'activated-item' : ''}`}
        draggable="true"
        style={{ position: 'relative', overflow: 'visible' }}
      >
        <img
          ref={imageRef}
          className=""
          src={image}
          alt="avatar"
          draggable="true"
          onDragStart={(event) => {
            console.log('event', event);
            dragStart(event);
          }}
        />
        {isUserUploadedLogo && !isMobile && (
          <button
            className="logo-delete-btn"
            onClick={handleDeleteClick}
            style={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              width: '20px',
              height: '20px',
              borderRadius: '50%',
              border: '2px solid white',
              backgroundColor: '#dc3545',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
              zIndex: 10000,
              boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
              pointerEvents: 'auto',
            }}
            title="Delete logo"
          >
            <span
              style={{
                color: 'white',
                fontSize: '14px',
                fontWeight: 'bold',
                lineHeight: '20px',
                height: '20px',
                width: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: 0,
                padding: 0,
                marginBottom: '2px',
                userSelect: 'none',
              }}
            >
              ×
            </span>
          </button>
        )}
      </div>
      {isUserUploadedLogo && isMobile && (
        <button
          className="logo-delete-btn"
          onClick={handleDeleteClick}
          style={{
            position: 'absolute',
            top: '-6px',
            right: '-6px',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            border: '2px solid white',
            backgroundColor: '#dc3545',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            zIndex: 10000,
            boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
            pointerEvents: 'auto',
          }}
          title="Delete logo"
        >
          <span
            style={{
              color: 'white',
              fontSize: '14px',
              fontWeight: 'bold',
              lineHeight: '20px',
              height: '20px',
              width: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: 0,
              padding: 0,
              marginBottom: '2px',
              userSelect: 'none',
            }}
          >
            ×
          </span>
        </button>
      )}
    </div>
  );
}
